import pathToRegexp from 'path-to-regexp';

// as of August 2017, there is no relative path support in react-router v4: https://github.com/ReactTraining/react-router/issues/4428

let paths = {
    faq: '/aide',
    contact: '/contact',
    cgu: '/cgu',
    buyXXL: '/bobtv-xxl',
    login: '/connexion',
    register: '/enregistrement',
    activateRegistration: '/activate-registration/:sid',

    profiles_default: '/membres',
    profiles: '/membres/:query?',

    member: '/membre',
    memberAlbum: '/membre/album',
    memberAmateurFilms: '/membre/videos-amateurs',
    memberWallMaterials: '/membre/le-mur',
    memberVirtualGifts: '/membre/cadeaux-virtuels',
    memberWishlist: '/membre/liste-d-envies',
    memberGuestbook: '/membre/livre-d-or',
    memberPaymentHistory: '/membre/historique-des-paiements',
    memberMessageDialog: '/membre/conversation/',
    memberMessageListTrash: '/membre/message-trash',
    memberMessageListMessages: '/membre/message-list',
    
    memberMessagePmConversations: '/membre/pm/conversations',
    memberMessagePmRequests: '/membre/pm/requests',
    memberMessagePmArchive: '/membre/pm/archive',

    memberMessagePmConversationsItem: '/membre/pm/conversations/:uid',

    memberWallet: '/membre/wallet',
    memberWalletCharge: '/membre/wallet/charge',
    memberWalletHistory: '/membre/wallet/history',
    memberWalletReplenish: '/membre/wallet/replenish',
    memberFollowing: '/membre/following',
    memberFollowers: '/membre/followers',
    memberBlackList: '/membre/black_list',
    memberNotificationList: '/membre/notification-list',
    memberNotificationSetting: '/membre/notification-settings',

    profile: '/profil/:nick',
    profileAlbum: '/profil/:nick/album',
    profileAmateurFilms: '/profil/:nick/videos-amateurs',
    profileWallMaterials: '/profil/:nick/le-mur',
    profileWishlist: '/profil/:nick/liste-d-envies',
    profileGuestbook: '/profil/:nick/livre-d-or',

    amateurFilm: '/film/:id',
    amateurFilms: '/films-amateurs/:slug?',
    wall: '/le-mur',
    wallMaterial: '/le-mur/material/:id',
    wardrobe: '/dressing',
    virtualGifts: '/cadeaux-virtuels',
    wishlists: '/les-listes-d-envies',

    paymentOrder: '/membre/payment-order'
};

let pathsExtended = {};

for (let index in paths) {
    let path = paths[index];

    pathsExtended[index] = {
        path,
        toPath: pathToRegexp.compile(path)
    }
}

export default pathsExtended;


// WEBPACK FOOTER //
// ./src/paths.js